<script lang="ts">

    import LoadingView from "./LoadingView.svelte";

    export let isLoading = false;
    export let paddingLeft = 0;
    export let paddingTop = 0;
    export let isCenter = false;


    $: loadingAreaStyle = (() => {
        let style = '';

        return style;
    })();

    $: loadingStyle = (() => {
        let style = '';
        if (paddingLeft > 0) {
            style += `padding-left: ${paddingLeft}px;`;
        }
        if (paddingTop > 0) {
            style += `padding-top: ${paddingTop}px;`;
            // bottom にも同じ
            style += `padding-bottom: ${paddingTop}px;`;
        }

        if (isCenter) {
            style += 'justify-content: center;';
        }

        return style;
    })();


</script>

<div class="loading-content-view">
    <div class="loading-area" style={loadingAreaStyle}
         class:show={isLoading}
    >
        <div class="loading" style={loadingStyle}>
            <LoadingView/>
            <LoadingView/>
            <svg class="text">
                <use xlink:href="/img/loading.svg#svg"/>
            </svg>


            <LoadingView/>
            <LoadingView/>

        </div>

    </div>
    <slot/>

</div>

<style lang="scss">
    .loading-content-view {
        position: relative;
        width: 100%;
        height: 100%;
        min-height: 30px;

        .loading-area {
            z-index: var(--loading-content-view-z-index);

            position: absolute;
            width: 100%;
            height: 100%;

            transition-duration: 0.5s;

            opacity: 0;
            pointer-events: none;

            > .loading {
                display: flex;
                align-items: center;
                background: linear-gradient(90deg, transparent 0%, #fffa calc(0% + 10px), #fffa calc(100% - 10px), transparent 100%);

                width: 100%;
                height: 100%;


                .text {
                    height: 18px;
                    width: 160px;
                }

                :global(.loading-view) {
                    height: 30px;

                }

            }

            &.show {
                opacity: 1;
                pointer-events: all;

            }


        }

    }
</style>